import api from '@/lib/api';

export interface AutoReply {
  id: string;
  organization_id: string;
  template_html: string;
  template_text: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  updated_by: string | null;
  organization_name?: string;
}

export interface CreateAutoReplyData {
  templateHtml: string;
  templateText?: string;
}

export interface AutoReplyResponse {
  success: boolean;
  data: AutoReply;
  message?: string;
}

export interface AutoRepliesResponse {
  success: boolean;
  data: AutoReply[];
}

export interface ToggleAutoReplyData {
  isActive: boolean;
}

class AutoRepliesService {
  // Get all auto-replies for current user
  async getAllAutoReplies(): Promise<AutoRepliesResponse> {
    const response = await api.get<AutoRepliesResponse>('/auto-replies');
    return response.data;
  }

  // Get auto-reply for specific organization
  async getAutoReply(organizationId: string): Promise<AutoReplyResponse> {
    const response = await api.get<AutoReplyResponse>(`/auto-replies/${organizationId}`);
    return response.data;
  }

  // Create or update auto-reply for organization
  async upsertAutoReply(
    organizationId: string,
    data: CreateAutoReplyData
  ): Promise<AutoReplyResponse> {
    const response = await api.post<AutoReplyResponse>(
      `/auto-replies/${organizationId}`,
      data
    );
    return response.data;
  }

  // Delete auto-reply
  async deleteAutoReply(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/auto-replies/${organizationId}`);
    return response.data;
  }

  // Toggle auto-reply active status
  async toggleAutoReplyStatus(
    organizationId: string,
    isActive: boolean
  ): Promise<AutoReplyResponse> {
    const response = await api.patch<AutoReplyResponse>(
      `/auto-replies/${organizationId}/toggle`,
      { isActive }
    );
    return response.data;
  }
}

export default new AutoRepliesService();
